export default function FooterBottomBar() {
  return (
    <div className="border-t border-white/10">
      <div className="max-w-7xl mx-auto px-4 md:px-8 py-5 flex flex-col sm:flex-row items-center justify-between gap-3">
        <p className="text-white/30 text-xs">
          &copy; 2026 Fast Passport Center. All rights reserved.
        </p>
        <div className="flex items-center gap-4">
          <a href="https://fastpassportcenter.com/privacy-policy/" target="_blank" rel="noopener noreferrer" className="text-white/30 hover:text-white/60 text-xs transition-colors whitespace-nowrap">Privacy Policy</a>
          <a href="https://fastpassportcenter.com/terms-and-conditions/" target="_blank" rel="noopener noreferrer" className="text-white/30 hover:text-white/60 text-xs transition-colors whitespace-nowrap">Terms &amp; Conditions</a>
          <a href="/llms.txt" className="text-white/30 hover:text-white/60 text-xs transition-colors whitespace-nowrap">LLMs.txt</a>
        </div>
      </div>
    </div>
  );
}